module.exports = __webpack_public_path__ + "img/Butterfly_00141.9c0f789d.png";